<div class="dialog-content otp-content">
  <!--title 標題-->
  @if (!data.hideCancel) {
    @if (data.isCreate) {
      <h1 class="dialog-title">
        {{ 'save-phone-dialog.create-title' | translate }}
      </h1>
    } @else {
      <h1 class="dialog-title">
        {{ 'save-phone-dialog.modify-title' | translate }}
      </h1>
    }
  } @else {
    <h1 class="dialog-title">
      {{ 'save-phone-dialog.required-title' | translate }}
    </h1>
    <p class="required-subtitle">
      {{ 'save-phone-dialog.required-subtitle' | translate }}
    </p>
  }

  <div class="dialog-form otp-form">
    <div class="input-block">
      <label class="input-title">{{
        'save-phone-dialog.enter-phone' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          type="tel"
          matInput
          [formControl]="phoneControl"
          appNumericOnly
          maxlength="10"
          [ngClass]="{ 'input-error': showPhoneError && phoneControl.invalid }"
          [placeholder]="
            'save-phone-dialog.enter-phone-placeholder' | translate
          "
        />
        <button
          mat-button
          [disabled]="!isSendOtpAvailable"
          (click)="sendOtp()"
          class="btn-text-primary input-otp-btn"
        >
          {{ 'save-phone-dialog.send-otp' | translate }}
          @if (!isSendOtpAvailable) {
            ({{ otpRemainSeconds }}s)
          }
        </button>
        @if (showPhoneError && phoneControl.invalid) {
          <mat-error class="input-error-msg">{{
            getPhoneErrorMessage()
          }}</mat-error>
        }
      </div>
    </div>

    <div class="input-block">
      <label class="input-title">{{
        'save-phone-dialog.enter-phone-otp' | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          matInput
          [formControl]="otpControl"
          [ngClass]="{ 'input-error': showOtpError && otpControl.invalid }"
          [placeholder]="
            'save-phone-dialog.enter-phone-otp-placeholder' | translate
          "
        />
        @if (showOtpError && otpControl.invalid) {
          <mat-error class="input-error-msg">{{
            getOtpErrorMessage()
          }}</mat-error>
        }
      </div>
      @if (isOtpReachedLimit) {
        <div class="password-change-hint">
          <img
            width="16"
            height="16"
            ngSrc="assets/img/i-warn-outline.svg"
            alt=""
          />
          <span>{{ 'otp-dialog.otp-error-reach-limit' | translate }}</span>
        </div>
      }
    </div>
  </div>
  <div class="dialog-btn-block">
    <button mat-button class="btn-fill-primary btn-size-l" (click)="save()">
      {{
        data.isCreate
          ? ('save-phone-dialog.create-phone' | translate)
          : ('save-phone-dialog.modify-phone' | translate)
      }}
    </button>
    @if(!data.hideCancel){
    <button mat-button class="btn-text-underline btn-size-s" (click)="closeDialog()">
      {{ 'common.button.cancel' | translate }}
    </button>
    }
     @else if(!data.hideLater){
    <button mat-button class="btn-text-underline btn-size-s" (click)="laterFill()">
      {{ 'common.button.later-confirm' | translate }}
    </button>
    }
  </div>
</div>
@if(data.hideCancel){
  <!-- 底部提示文字-->
  <div class="register-notice-text">
    <p>若無可用手機號碼但仍需預約，</p>
    <p>請聯繫客服 02-412-8006</p>
  </div>
}
